import React from 'react';
import BookingFlow from './BookingFlow';
import KioskFlow from './KioskFlow';
import TrainingBooking from './TrainingBooking';
import FormsPage from './FormsPage';
import AdminReviews from './AdminReviews';
import './App.css';

function App() {
  // Route based on URL path:
  //   /kiosk              → Kiosk location picker
  //   /kiosk/:location    → Kiosk for specific location (e.g. /kiosk/lonsdale)
  //   /training           → Training services booking
  //   /forms              → Guest forms (standalone, mobile-friendly)
  //   /                   → Normal online booking
  //   Staff app moved to ops.cutiepiewaxbar.com
  const path = window.location.pathname;
  const isKiosk = path.startsWith('/kiosk');
  const isTraining = path.includes('/training');
  const isForms = path.startsWith('/forms');
  const isAdmin = path.startsWith('/admin');

  // Extract location slug from /kiosk/:location
  const kioskLocation = isKiosk ? (path.split('/kiosk/')[1] || '').replace(/\/$/, '') || null : null;

  // Request fullscreen for kiosk to hide Android status bar
  React.useEffect(() => {
    if (isKiosk && document.documentElement.requestFullscreen) {
      const goFullscreen = () => {
        document.documentElement.requestFullscreen().catch(() => {});
        document.removeEventListener('click', goFullscreen);
      };
      // Fullscreen requires a user gesture — trigger on first tap
      document.addEventListener('click', goFullscreen);
      return () => document.removeEventListener('click', goFullscreen);
    }
  }, [isKiosk]);

  return (
    <div className="App">
      {isAdmin ? <AdminReviews /> : isForms ? <FormsPage /> : isKiosk ? <KioskFlow location={kioskLocation} /> : isTraining ? <TrainingBooking /> : <BookingFlow />}
    </div>
  );
}

export default App;
